// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://rxbvyghqijummalcgouh.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJ4YnZ5Z2hxaWp1bW1hbGNnb3VoIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDQ3NjQ0MjUsImV4cCI6MjA2MDM0MDQyNX0.qILKXUXWH1a83XiQocLIC2CdDdZVabJkfzRVVibZA6Q";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);